module.exports = __webpack_public_path__ + "static/media/005-mortar.14b17b55.svg";